// removed by extract-text-webpack-plugin
module.exports = {"main":"_2yvRo1G9xq8iPDQxxH-MDw"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/pc/PcFullColumn.scss
// module id = 942
// module chunks = 12